import { render, staticRenderFns } from "./ServiceProjectManage.vue?vue&type=template&id=8e8ee4a2&scoped=true"
import script from "./ServiceProjectManage.vue?vue&type=script&lang=js"
export * from "./ServiceProjectManage.vue?vue&type=script&lang=js"
import style0 from "./ServiceProjectManage.vue?vue&type=style&index=0&id=8e8ee4a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8ee4a2",
  null
  
)

export default component.exports